export default __webpack_public_path__ + "static/media/circles-no-1.3ca89346.mp3";